import { useState } from "react";

const useSnackbar = () => {
  const [snackBar, setSnackBar] = useState({
    open: false,
    message: "",
    autoHideDuration: 10000,
    handleClose: () => setSnackBar((pre) => ({ ...pre, open: false })),
  });

  return [snackBar, setSnackBar];
}

export { useSnackbar };
